var map = {
	"./exhibit-icon.png": "1945",
	"./hint-icon.png": "c0f5",
	"./record-icon.png": "d63f",
	"./related-icon.png": "95a4",
	"./shop-icon.png": "9018",
	"./soul-icon.png": "3dea",
	"./time-icon.png": "5498",
	"./yama/yama-icon.png": "a86a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1a12";